import { Component, OnInit, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ProductManagementModel } from './shared';


@Pipe({
  name: 'mapToIterable'
})
export class MapToIterable implements PipeTransform {
  transform(value: any, args?: any[]): Object[] {
    const returnArray = [];
    value.forEach((entryVal: Map<string, Array<ProductManagementModel>>, entryKey: string) => {
      returnArray.push({
        key: entryKey,
        val: entryVal
      });
    });
    return returnArray;
  }
}
